import {useMemo, useState} from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'

import {filterMoreWordings, filterSortWordings} from 'js/helpers/drupalSettings'
import Button from 'js/components/shared/Button';

import styles from './FilterDetailedButton.module.scss';
import FilterDetailedModal from '../FilterDetailedModal';

const cx = classnames.bind(styles);
const BUTTON_OFF = '0';

const buttonDefaultValue = filterMoreWordings?.title || 'Filters'

const FilterDetailedButton = ({
  className,
  makePrediction,
  resultsCount,
  moreFilters,
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const {
    hotelType,
    priceRange,
    amenities
  } = moreFilters || {}

  const filtersCount = useMemo(function () {
    const hotelTypeValues = Object.values(hotelType || {}).filter(el => el !== BUTTON_OFF)
    const amenitiesValues = Object.values(amenities || {}).filter(el => el !== BUTTON_OFF)
    const priceRangeValues = Object.values(priceRange || {}).filter(el => !!el)
    const filters = [
      ...(hotelTypeValues),
      ...(priceRangeValues),
      ...(amenitiesValues)
    ]
    return filters.filter(el => !!el).length
  }, [hotelType, priceRange, amenities])

  const openFiltersModal = (e) => {
    e.preventDefault();
    setIsOpened(true);
  }

  const onModalClose = function () {
    setIsOpened(false);
  }

  return filtersCount > 0 || resultsCount >= 10 ? (
    <>
      <Button
        className={cx('button', className)}
        color={filtersCount > 0 ? 'main-reverse' : 'black-reverse'}
        onClick={openFiltersModal}
      >
        <i className={cx('icon-filtering-icon')} />
        {buttonDefaultValue}
        {!!filtersCount && (<span className={cx('counter')}>{filtersCount}</span>)}
      </Button>
      {isOpened && (
        <FilterDetailedModal
          titles={filterMoreWordings}
          sortTitles={filterSortWordings}
          resultsCount={resultsCount}
          title={filterMoreWordings?.title}
          applyTitle={filterMoreWordings?.apply}
          clearLabel={filterMoreWordings?.clear}
          makePrediction={makePrediction}
          onClose={onModalClose}
        />
      )}
    </>
  ) : null;
}

FilterDetailedButton.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  onUpdate: PropTypes.func,
  resultsCount: PropTypes.number,
  submitDisabled: PropTypes.bool,
  sort: PropTypes.string,
  more: PropTypes.shape({
    hotelType: PropTypes.any,
    priceRange: PropTypes.any,
    amenities: PropTypes.any,
  })
}

const state2Props = ({
  url
}) => ({
  moreFilters: {
    hotelType: url.parameters.hotelType,
    priceRange: url.parameters.priceRange,
    amenities: url.parameters.amenities,
  },
  sort: url.uiParams.sort,
})

const actions2Props = {}

export default connect(
  state2Props,
  actions2Props
)(FilterDetailedButton);
